import { create } from 'zustand';

import { createFetchCacheSlice } from './actions';
import { FetchCacheStore } from './types';

export const useFetchCacheStore = create<FetchCacheStore>()(
  (set, get, store) => ({
    ...createFetchCacheSlice(set, get, store),
  }),
);
